<template>
  <div>
    <v-combobox
        v-model="selected_wholesaler"
        :items="wholesaler_list"
        :label="$lang.RETAILER"
        :loading="loading"
        :placeholder="$lang.WHOLESALER"
        :rules="$rules.wholesalerRule"
        :search-input.sync="wholesaler_search_query"
        append-icon="mdi-menu-down"
        clearable
        dense
        item-text="firm_name"
        item-value="wholesaler_id"
        outlined
        single-line
        @change="updateWholesaler"
        @focus="wholesalerAutoComplete"
        @keydown="wholesalerAutoComplete"
    >
      <template v-slot:item="data">
        <v-list-item-content>
          <v-list-item-title v-html="data.item.firm_name"></v-list-item-title>
          <v-list-item-subtitle>{{ $lang.MOBILE_PREFIX }}{{ data.item.mobile }}</v-list-item-subtitle>
        </v-list-item-content>
      </template>

    </v-combobox>
  </div>
</template>
<script type="text/javascript">

export default {
  props: ['is_withdraw'],
  data() {
    return {
      loading: false,
      wholesaler_list: [],
      wholesaler_search_query: "",
      selected_wholesaler: null
    }
  },
  created() {
    console.log(this.$route.name)
    if (this.$route.name == "initiate-withdrawal")
      this.selected_wholesaler = this.$store.state.initiate_withdrawal.wholesaler
  },
  methods: {
    updateWholesaler() {
      this.$emit("update-wholesaler", this.selected_wholesaler);

    },
    wholesalerAutoComplete() {
      const self = this
      let params = {
        "is_active": true,
        "search_query": self.wholesaler_search_query,
      };
      if (self.is_withdraw)
        params.is_withdraw = self.is_withdraw
      self.loading = true;
      const successHandler = (response) => {
        self.wholesaler_list = response.data.wholesaler_list

      };
      const finallyHandler = () => {
        self.loading = false
      };
      self.request_GET(self, self.$urls.WHOLESALER_LIST, params, successHandler, null, null, finallyHandler, true)


    }
  }
}
</script>